import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as async from "async";
import * as deviceDetect from "deviceDetect";
import * as envelope from "envelope";
import * as keyboardShortcuts from "keyboardShortcuts";
import readlangClient from "readlangClient";
import * as videoPlayer from "videoPlayer";

const SyncAudioView = Backbone.View.extend({
  saveSyncPoint: function (audioMap) {
    const that = this;
    if (this.blocked) {
      this.audioMapToSave = audioMap;
    } else {
      this.blocked = true;
      that.model.save(
        { audioMap: audioMap },
        {
          patch: true,
          success: function () {
            that.saveTimer = setTimeout(() => {
              that.blocked = false;
              if (that.audioMapToSave) {
                that.saveSyncPoint(that.audioMapToSave);
                delete that.audioMapToSave;
              }
            }, 500);
          },
          error: function () {
            console.error("error saving sync point");
            that.blocked = false;
            if (that.audioMapToSave) {
              that.saveSyncPoint(that.audioMapToSave);
              delete that.audioMapToSave;
            }
          },
        }
      );
    }
  },
  initialize: function (options) {
    this.options = options || {};
    const that = this;
    this.started = false;
    videoPlayer.reset();

    $("#removeYouTube").click(() => {
      readlangClient.request(
        "DELETE",
        "/api/book/" + that.model.id + "/youTubeID",
        {},
        () => {
          window.location.href = "/library/" + that.model.id;
        },
        (data) => {
          console.error("error deleting YouTubeID", data);
        }
      );
    });

    const idOnlyRegExp = /^[a-zA-Z0-9_-]{11}$/;
    // cspell: disable-next-line
    const idInURLRegExp = /(v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    $("#saveYouTubeID").click(() => {
      const userInput = $("#youTubeID").val()!;
      let newID;

      if (idOnlyRegExp.test(userInput.toString())) {
        newID = userInput;
      } else {
        const match = idInURLRegExp.exec(userInput.toString());
        if (match && match[2]) {
          newID = match[2];
        }
      }

      if (!newID) {
        alert("YouTube URL or ID not valid. The ID must be 11 characters.");
        return;
      }

      async.series(
        [
          (callback) => {
            callback();
            /* this isn't working - TODO: is there a different API call?
             * 
            // check google to see if the id is valid
            $.ajax({
              type: "GET",
              url: '//gdata.youtube.com/feeds/api/videos/' + newID,
              success: function (data, textStatus, jqXHR) {
                console.log('success');
                return;
                callback();
              },
              error: function () {
                alert('No YouTube video found with this ID.');
                return;
                callback();
              }
            });
            */
          },
        ],
        () => {
          // TODO: check youtube video exists, fetch metadata
          that.model.save(
            { youTubeID: newID },
            {
              patch: true,
              success: function () {
                window.location.reload();
              },
            }
          );
        }
      );
    });
    $("#saveNextBookID").click(() => {
      const nextID = $("#nextBookID").val();

      that.model.save(
        { nextBookID: nextID },
        {
          patch: true,
          success: function () {
            window.location.reload();
          },
        }
      );
    });

    $(".youTubeTabLink").attr(
      "href",
      `https://www.youtube.com/watch?v=${this.model.get("youTubeID")}`
    );

    let scrolled = false;
    $("#youTubeTranscriptWithTimings").on("input", () => {
      if (!scrolled) {
        const submitButton = $("#submitYouTubeTranscript");
        const youTubeTab = $(".tabContent[data-tab=youTube]");

        submitButton.fadeIn();
        youTubeTab.animate({
          scrollTop:
            submitButton.offset().top -
            youTubeTab.height() +
            submitButton.height(),
        });
        scrolled = true;
      }
    });

    $("#submitYouTubeTranscript").click(async () => {
      const transcript = $("#youTubeTranscriptWithTimings").val();
      const response = await readlangClient.request(
        "POST",
        `/api/book/${this.model.id}/addTimings`,
        {
          transcript,
          force: false,
        }
      );

      const updateTimings = (audioMap) => {
        that.model.set({ audioMap });
        that.updateAudioPosition({ animateTime: 200 });
        that.highlightSyncWords();
        alert("Transcript timings updated successfully.");
      };

      if (response.data.updated) {
        updateTimings(response.data.audioMap);
        return;
      }

      if (response.data.prompt && !confirm(response.data.message)) {
        return;
      } else if (!response.data.prompt) {
        alert(response.data.message);
        return;
      }

      const response2 = await readlangClient.request(
        "POST",
        `/api/book/${this.model.id}/addTimings`,
        {
          transcript,
          force: true,
        }
      );

      if (response2.data.updated && response2.data.audioMap) {
        updateTimings(response2.data.audioMap);
        return;
      }

      alert("Failed to update transcript.");
      console.error(response);
    });

    const audioUploadElement = $("#audioUpload");
    audioUploadElement.change((event) => {
      // @ts-ignore
      const files = event.target.files;

      if (files.length !== 1) {
        console.error("only works with one file");
      }
      const file = files[0];

      if (!/\.mp3$/.test(file.name)) {
        alert("Readlang only supports .mp3 files for now.");
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert("Readlang only supports files up to 5Mb for now.");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        "/api/library/" + that.model.get("_id") + "/audio",
        true
      );
      xhr.onload = () => {
        window.location.href = "/library/" + that.model.get("_id");
      };

      const progressBar = $("#audioUploadProgress");

      xhr.upload.addEventListener(
        "progress",
        (uploadProgressEvent) => {
          progressBar.attr("value", uploadProgressEvent.loaded);
          progressBar.attr("max", uploadProgressEvent.total);
        },
        false
      );

      xhr.send(formData);
    });

    if (this.model.has("youTubeID")) {
      this.mediaPlayer = videoPlayer;
    }

    if (!this.mediaPlayer) {
      $("body").removeClass("syncAudio");
      return;
    }

    // We are in media mode, so set page to scroll
    that.options.setPageMode("scroll");

    $("body").addClass("syncAudio");

    keyboardShortcuts.registerHandler("readerPage", "x".charCodeAt(0), () => {
      $("#toggle-translate").click();
    });
    keyboardShortcuts.registerHandler("readerPage", "c".charCodeAt(0), () => {
      $("#toggle-sync").click();
    });
    keyboardShortcuts.registerHandler("readerPage", "v".charCodeAt(0), () => {
      $("#toggle-goto").click();
    });
    keyboardShortcuts.registerHandler(
      "readerPage",
      " ".charCodeAt(0),
      (event) => {
        event?.preventDefault();
        if (that.mediaPlayer.status().paused) {
          that.mediaPlayer.play();
        } else {
          that.mediaPlayer.pause();
        }
      }
    );
    keyboardShortcuts.registerHandler(
      "readerPage",
      83 /* s */,
      () => {
        that.mediaPlayer.toggleSpeed();
      },
      true,
      true,
      "ctrl"
    );

    keyboardShortcuts.registerHandler(
      "readerPage",
      " ".charCodeAt(0),
      () => {
        event.preventDefault();
        if (that.mediaPlayer.status().paused) {
          that.mediaPlayer.play();
        } else {
          that.mediaPlayer.pause();
        }
      },
      true,
      true,
      "ctrl"
    );
    keyboardShortcuts.registerHandler(
      "readerPage",
      ",".charCodeAt(0),
      () => {
        that.mediaPlayer.jumpBack();
      },
      true,
      false,
      "ctrl"
    );
    keyboardShortcuts.registerHandler(
      "readerPage",
      ".".charCodeAt(0),
      () => {
        that.mediaPlayer.jumpForward();
      },
      true,
      false,
      "ctrl"
    );

    if (
      !this.model.has("audioMap") ||
      this.model.get("audioMap").length === 0
    ) {
      this.model.save({ audioMap: [{ t: 0, w: 0 }] }, { patch: true });
    }

    $("#footer #pageNumber").hide();

    this.currentAudioTime = 0;
    this.audioMapTable = this.$el.find(".audioMap");

    this.listenTo(
      this.options.readerViewModel,
      "change",
      this.updateAudioPosition
    );
    this.listenTo(this.options.readerViewModel, "change", this.updatePage);
    this.listenTo(this.model, "change", this.renderAudioMap);

    this.renderAudioMap();
    this.body = $("body");

    $("#audioInfo .totalWords").text(this.model.get("totalWords"));

    this.options.setMediaPanelHeight(
      Math.max(253, ($(window).height() - 40) / 2)
    );
    this.options.hideFooter();

    const resizer = $('<div id="resizer"></div>');
    const clickActionToggles = $(
      '<div class="clickActionToggles">' +
        '<input type="radio" name="clickAction" id="toggle-translate" value="translate" checked /><label for="toggle-translate" class="selected" title="Translate Mode (keyboard shortcut: w)">Translate</label> ' +
        (() => {
          if (that.options.owner) {
            return '<input type="radio" name="clickAction" id="toggle-sync" value="sync" /><label for="toggle-sync" title="Sync Mode (keyboard shortcut: e)">Sync</label> ';
          } else {
            return "";
          }
        })() +
        '<input type="radio" name="clickAction" id="toggle-goto" value="goto" /><label for="toggle-goto" title="Play Mode (keyboard shortcut: r)">Play</label>' +
        '<input type="radio" name="clickAction" id="toggle-disabled" value="disabled" /><label for="toggle-disabled">Disable Sync</label>' +
        '<div id="clickModeStatus">' +
        '<span class="syncMode">' +
        "<strong>Sync Mode:</strong> click on a word below exactly when you hear it to synchronize it with " +
        "</span>" +
        '<span class="playMode">' +
        "<strong>Play Mode:</strong> click on a word below to start playing from that point the audio" +
        "</span>" +
        '<span class="translateMode">' +
        "<strong>Translate Mode:</strong> click on a word below to translate it" +
        "</span>" +
        "</div>" +
        "</div>"
    ).css({
      "font-size": 12,
    });
    let playerElement = $('<div id="mediaPlayer" />');
    this.options.mediaPanel.append(playerElement);
    this.options.mediaPanel.append(clickActionToggles);
    this.options.mediaPanel.append(resizer);

    if (deviceDetect.is("iOS")) {
      clickActionToggles.hide();
    }

    const mouseMove = (event) => {
      const delta = event.pageY - dragStartY;
      that.options.setMediaPanelHeight(originalHeight + delta);
    };
    const mouseUp = () => {
      dragSurface.remove();
      $(document).off("mousemove.readlangDrag");
      $(document).off("mouseup.readlangDrag");
    };

    let dragStartY;
    let originalHeight;
    let dragSurface;
    $("#clickActionToggles").css({ height: "100px", "z-index": 5 });
    $("#resizer").on("mousedown", (event) => {
      originalHeight = that.options.mediaPanelHeight();
      dragStartY = event.pageY;

      playerElement = $("#mediaPlayer");

      // put transparent div over whole screen to avoid iframe capturing movements
      dragSurface = $('<div id="dragSurface"></div>').css({
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        "z-index": 5,
        cursor: "ns-resize",
        "-webkit-user-select": "none",
      });
      $("body").append(dragSurface);

      $(document).on("mousemove.readlangDrag", mouseMove);
      $(document).on("mouseup.readlangDrag", mouseUp);
    });

    let audioStart = 0;
    if (typeof that.options.startPosition === "number") {
      const buffer = 4;
      audioStart = Math.max(
        0,
        envelope.getTime(
          this.model.get("audioMap"),
          that.options.startPosition
        ) - buffer
      );

      // If the audio position of the first word is < 5 mins, start from the beginning
      if (that.options.startPosition === 0 && audioStart < 300 - buffer) {
        audioStart = 0;
      }
    }

    videoPlayer.loadVideo({
      playerElement,
      youTubeID: this.model.get("youTubeID"),
      onTimeUpdate: function (currentTime) {
        if (that.disabled) {
          return;
        }
        that.updateAudioPosition({
          currentTime: currentTime,
          animateTime: 100,
          scroll: that.options.scroll,
        });

        if (deviceDetect.is("iOS") && that.started === false) {
          clickActionToggles.fadeIn(500);
          that.started = true;
        }
      },
      onReady: function (newDuration) {
        const audioMap = _.clone(that.model.get("audioMap"));

        if (_.last(audioMap).w < that.model.get("totalWords") - 1) {
          envelope.addPoint(audioMap, {
            t: newDuration,
            w: that.model.get("totalWords") - 1,
          });
          that.model.save({ audioMap: audioMap }, { patch: true });
        }
      },
      onEnded: function () {
        if (that.disabled) {
          return;
        }
        that.options.markAsCompleted();
        let frames = 0;
        const intervalID = setInterval(() => {
          that.updateAudioPosition({ scroll: true });
          frames++;
          if (frames > 30) {
            clearInterval(intervalID);
          }
        }, 50);

        if (that.model.has("nextBookID") && confirm("Play the next chapter?")) {
          that.options.appRouter.navigate(
            "library/" + that.model.get("nextBookID") + "/scroll/0",
            { trigger: true }
          );
        }
      },
      onBuffering: function () {
        if (deviceDetect.is("iOS") && that.started === false) {
          clickActionToggles.fadeIn(500);
          that.started = true;
        }
      },
      start: audioStart,
    });

    this.options.spanTranslator.addClickHandler("sync", (span) => {
      span = $(span);

      const newPoint = {
        t: Math.round(that.currentAudioTime * 100) / 100,
        w: parseInt(span.attr("data-p"), 10),
      };
      const audioMap = _.clone(that.model.get("audioMap"));
      envelope.addPoint(audioMap, newPoint);

      that.model.set({ audioMap: audioMap });
      that.saveSyncPoint(audioMap);
      that.updateAudioPosition({ animateTime: 200 });
      that.highlightSyncWords();
    });

    this.options.spanTranslator.addClickHandler("goto", (span) => {
      span = $(span);
      that.gotoWord(parseInt(span.attr("data-p"), 10));
    });

    const onClickActionChange = () => {
      console.log("click action change");
      const clickMode = $('input[name="clickAction"]:checked').val();
      that.body.attr(
        "data-clickMode",
        clickMode === "disabled" ? "translate" : clickMode
      );

      $(".clickActionToggles label").removeClass("selected");

      switch (clickMode) {
        case "sync":
          $('.clickActionToggles label[for="toggle-sync"]').addClass(
            "selected"
          );
          that.highlightSyncWords();
          that.disabled = false;
          break;
        case "goto":
          $('.clickActionToggles label[for="toggle-goto"]').addClass(
            "selected"
          );
          that.unhighlightSyncWords();
          that.disabled = false;
          break;
        case "translate":
          $('.clickActionToggles label[for="toggle-translate"]').addClass(
            "selected"
          );
          that.unhighlightSyncWords();
          that.disabled = false;
          break;
        case "disabled":
          $('.clickActionToggles label[for="toggle-disabled"]').addClass(
            "selected"
          );
          that.unhighlightSyncWords();
          $("span[data-p]").removeClass("audioPosition");
          that.disabled = true;
          break;
        default:
      }
      showClickModeHint(clickMode);
      startFadeOutTimer();
    };

    var showClickModeHint = (clickMode) => {
      switch (clickMode) {
        case "sync":
          $("#clickModeStatus")
            .html(
              "<strong>Sync Mode:</strong> click on a word below exactly when you hear it to synchronize it with " +
                "the audio"
            )
            .css("display", "block");
          break;
        case "goto":
          $("#clickModeStatus")
            .html(
              "<strong>Play Mode:</strong> click on a word below to start playing from that point"
            )
            .css("display", "block");
          break;
        case "translate":
          $("#clickModeStatus")
            .html(
              "<strong>Translate Mode:</strong> click on a word below to translate it (with audio sync on)"
            )
            .css("display", "block");
          break;
        case "disabled":
          $("#clickModeStatus")
            .html(
              "<strong>Disable Sync Mode:</strong> click on a word below to translate it (with audio sync off)"
            )
            .css("display", "block");
          break;
        default:
      }
    };

    let fadeHintTimeout;
    var startFadeOutTimer = (selectedHint?: string) => {
      clearTimeout(fadeHintTimeout);

      if (selectedHint && $("body").attr("data-clickMode") !== selectedHint) {
        $("#clickModeStatus").hide();
      } else {
        fadeHintTimeout = setTimeout(() => {
          $("#clickModeStatus").fadeOut(1000);
        }, 4500);
      }
    };

    $('input[name="clickAction"]').on("change", onClickActionChange);

    $('label[for="toggle-sync"]').hover(
      () => {
        showClickModeHint("sync");
      },
      () => {
        startFadeOutTimer("sync");
      }
    );
    $('label[for="toggle-goto"]').hover(
      () => {
        showClickModeHint("goto");
      },
      () => {
        startFadeOutTimer("goto");
      }
    );
    $('label[for="toggle-translate"]').hover(
      () => {
        showClickModeHint("translate");
      },
      () => {
        startFadeOutTimer("translate");
      }
    );
    $('label[for="toggle-disabled"]').hover(
      () => {
        showClickModeHint("disabled");
      },
      () => {
        startFadeOutTimer("disabled");
      }
    );

    onClickActionChange();
  },
  updatePage: function () {
    if (this.body.attr("data-clickMode") === "sync") {
      this.highlightSyncWords();
    }
  },
  highlightSyncWords: function () {
    $("span[data-p]").removeClass("audioSync");
    _.each(this.model.get("audioMap"), (point) => {
      $('span[data-p="' + point.w + '"]').addClass("audioSync");
    });
  },
  unhighlightSyncWords: function () {
    $("span[data-p]").removeClass("audioSync");
  },
  gotoWord: function (position) {
    if (!this.mediaPlayer) {
      return;
    }

    this.mediaPlayer.play(
      Math.max(
        0.01,
        envelope.getTime(this.model.get("audioMap"), position) - 0.5
      )
    );
    this.updateAudioPosition({ animateTime: 200 });
  },
  renderAudioMap: function () {
    const tableBody = this.audioMapTable.find("tbody");
    tableBody.children().remove();

    _.each(this.model.get("audioMap"), (point) => {
      tableBody.append(
        $("<tr/>").append($("<td/>").text(point.t), $("<td/>").text(point.w))
      );
    });
  },
  scrollTo: function (yPosition) {
    const pageTextViewport = $("#pageTextViewport");

    pageTextViewport.stop();
    pageTextViewport.scrollTop(
      pageTextViewport.scrollTop() * 0.85 - yPosition * 0.15
    );
  },
  updateAudioPosition: function (options) {
    if ("currentTime" in options) {
      this.currentAudioTime = options.currentTime;
    }
    const currentPosition = Math.round(
      envelope.getWord(this.model.get("audioMap"), this.currentAudioTime)
    );

    $("span[data-p]").removeClass("audioPosition");
    const currentSpan = $('span[data-p="' + currentPosition + '"]');

    this.options.gotoPosition(currentPosition);

    let newY;

    if (
      !this.options.readerViewModel.has("firstSpan") ||
      this.options.readerViewModel.get("firstSpan").length === 0 ||
      !this.options.readerViewModel.get("lastSpan") ||
      this.options.readerViewModel.get("lastSpan").length === 0
    ) {
      return;
    }

    const lastPosition = parseInt(
      this.options.readerViewModel.get("lastSpan").attr("data-p"),
      10
    );

    if (options.scroll && currentSpan.length > 0) {
      currentSpan.addClass("audioPosition");
      if (currentPosition === lastPosition) {
        // scroll to the end
        newY = -$("#pageText").height() + $("#pageTextViewport").height() - 100;
      } else {
        newY = Math.round(
          -currentSpan.position().top + $("#pageTextViewport").height() / 2
        );
      }

      const offset =
        (currentSpan.height() *
          (currentSpan.position().left + currentSpan.width() / 2)) /
        $("#pageText").width();

      if (this.options.textDirection === "RTL") {
        newY += offset - currentSpan.height();
      } else {
        newY -= offset;
      }

      if ($("body").attr("data-clickMode") !== "sync") {
        this.scrollTo(newY);
      }
      return;
    }

    if (currentSpan.length > 0 && currentPosition <= lastPosition) {
      currentSpan.addClass("audioPosition");
    }
  },
  status: function () {
    return this.mediaPlayer && this.mediaPlayer.status();
  },
  updateOptions: function (newOptions) {
    _.extend(this.options, newOptions);
  },
  remove: function () {
    if (this.mediaPlayer) {
      this.mediaPlayer.disable();
    }
    Backbone.View.prototype.remove.call(this);
    this.off();
  },
});

export default SyncAudioView;
